import axios from 'axios';

const API_KEY = process.env.REACT_APP_API_KEY;

const server = axios.create({ baseURL: process.env.REACT_APP_API_BASE_URL });

export const requests = {
    trendingThisWeek: `/trending/all/week?api_key=${API_KEY}&lang=en-US`,
    netflixOriginals: `/discover/tv?api_key=${API_KEY}&with_networks=213`,
    topRatedMovies: `/movie/top_rated?api_key=${API_KEY}&lang=en-US`,
    actionMovies: `/discover/movie?api_key=${API_KEY}&with_genres=28`,
    comedyMovies: `/discover/movie?api_key=${API_KEY}&with_genres=35`,
    horrorMovies: `/discover/movie?api_key=${API_KEY}&with_genres=27`,
    romanticMovies: `/discover/movie?api_key=${API_KEY}&with_genres=10749`,
    documentaries: `/discover/movie?api_key=${API_KEY}&with_genres=99`,
};

export default server;